module.exports = __webpack_public_path__ + "static/media/DevotchkaElephantClubFallTourflyer2011Handlettered2colorscreenprint.6e0064e1.webp";